















































import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BButton, BIconPlus, BModal } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import RoleFilter from '@/components/RoleFilter.vue';
import RoleList from '@/components/RoleList.vue';
import RoleDetails from '@/components/RoleDetails.vue';
import RoleFilterOptions from '@/types/RoleFilterOptions';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'data-table': DataTable,
        'role-filter': RoleFilter,
        'role-list': RoleList,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-modal': BModal,
        'role-details': RoleDetails
    }
})
export default class RolesView extends Vue {
    roleId = ''
    showModal = false;
    refreshList = false;
    modalTitle = '';
    filter: RoleFilterOptions = {
        sequenceOrName: null,
        isActive: true
    }

    onRoleSelected(id: string) {
        this.roleId = id;
        this.modalTitle = this.$t('modal.roleDetailsTitle') as string;
        this.showModal = true;
    }

    onLoadComplete() {
        this.refreshList = false;
    }

    onRoleSaved(result: boolean) {
        this.showModal = false;

        if (result) {
            this.refreshList = true;
        }
    }

    onRoleDeleted() {
        this.showModal = false;
        this.refreshList = true;
    }

    addNewRole() {
        this.roleId = '';
        this.modalTitle = this.$t('modal.newRoleTitle') as string;
        this.showModal = true;
    }

    onFilterList(filter: RoleFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }
}
